import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import BasicText from './basicText'
import BasicImage from './basicImage'
import {stepEnum} from './debtPaymentEnum'
import '../debtPayment.scss'

const PopUpComponent = (props) => {

    const arrow = require('../images/icons-arrow.svg')

    return (
      <Container className='debtpayment-modal'>
        <Container className='middle pr-0 pl-0'>
          <Container className='inner pr-0 pl-0'>
            <Row className='debtpayment-modal-title'>
              <Col>
                <BasicText text={props.title} />
              </Col>
            </Row>
            <Row className='debtpayment-modal-text'>
              <Col>
              {props.text && props.text !== '' && (
                 <BasicText text={props.text} />
              )}
              </Col>
            </Row>
            <Row className='justify-content-md-center'>
              <Col md='auto'>
                <div
                  onClick={() => {
                    props.closeModal();
                    props.onclick(stepEnum.CONTACTUS);
                  }}
                  className='debtpayment-modal-button'>
                  <BasicText text={props.buttonText} bold color='businessPurple'/>
                  <BasicImage src={arrow} classname='arrow-img' />
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
      </Container>
    );
}

export default PopUpComponent   